import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=c9ee15c0"
import script from "./Phone.js?vue&type=script&lang=js&external"
export * from "./Phone.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports